import React from 'react';
import PropTypes from 'prop-types';
import Align from '@marvelapp/marvel-ui/align';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';
import caseStudiesAssets from 'marketing-website/configs/caseStudies';

import Quote from '../../Quote';

import generalStyles from './style/general.module.css';

export default function HeroBlock({ boldTitle, name, title }) {
  const assets = caseStudiesAssets[name];
  const { heroLogo: Logo } = assets;

  return (
    <div className={generalStyles.hero}>
      <PageWrap size="m">
        <Align type="center">
          <Spacing size="l" sizeM="0" type="margin" position="bottom">
            <Spacing size="m" sizeS="l" sizeM="xl" type="padding">
              <MaxWidth value={960}>
                <Align type="center" typeM="left">
                  <Spacing size="m" position="topBottom" type="margin">
                    <Logo />
                  </Spacing>
                  <Quote
                    boldContent={boldTitle}
                    content={title}
                    headingSize="xxxxl"
                    tag="h1"
                  />
                </Align>
              </MaxWidth>
            </Spacing>
          </Spacing>
        </Align>
      </PageWrap>
    </div>
  );
}

HeroBlock.propTypes = {
  boldTitle: PropTypes.string,
  name: propTypeEmptyString,
  title: propTypeEmptyString,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/Hero/index.js